export const API_URL = process.env.REACT_APP_API_URL;

export interface Studio {
  id: string;
  title: string;
  imageSrc: string;
}

export interface Admin {
  id: string;
  name: string;
  surname: string;
  imageSrc: string;
  studio: Array<Studio>;
  email: string;
}

export interface ServicesCategory {
  id: string;
  name: string;
  surname: string;
  imageSrc: string;
  // eslint-disable-next-line no-use-before-define
  subCategories: Array<ServicesSubCategory>;
}

export interface ServicesSubCategory {
  id: string;
  name: string;
  surname: string;
  imageSrc: string;
}

export interface Services {
  id: string;
  serviceName: string;
  category: Array<ServicesCategory>;
  hours: number;
  minutes: number;
  noRank: number;
  junior: number;
  master: number;
  top: number;
  employee: string;
}

export interface EmployeeStudio {
  id: string;
  name: string;
  imageSrc: string;
  streetName: string;
  date: {
    startDate: string;
    period: string;
  };
  regularHours: {
    from: string;
    to: string;
    weekdays: string[];
  };
}

export interface EmployeeServices {
  id: string;
  name: string;
  imageSrc: string;
  rank: string;
}

export interface Employees {
  id: string;
  name: string;
  surName: string;
  email: string;
  imageSrc: string;
  skillName: string;
  rank: string;
  orders: number;
  studios: Array<EmployeeStudio>;
  services: Array<EmployeeServices>;
}

export interface BookingsDateSections<I, N> {
  id: I;
  name: N;
}

export interface BookingsStatus {
  id: string;
  backgroundColor: string;
  color: string;
  title: string;
}

export interface Bookings {
  id: string;
  imageSrc: string;
  email: string;
  firstName: string;
  lastName: string;
  rank: string;
  status: BookingsStatus[];
  studio: BookingsDateSections<string, string>;
  service: BookingsDateSections<string, string>;
  customer: BookingsDateSections<string, string>;
  startProcedure: {
    dateTime: string;
    dateDay: string;
    dateYear: string;
  };
  serviceDuration: {
    timeHours: string;
    timeMinutes: string;
  };
  payment: {
    paymentMethod: string;
    paymentPrice: string;
  };
}
